import type { XYPosition } from '../types';

/** The box a shape outline fills (already pulled in by the stroke inset). */
export type Box = { x: number; y: number; width: number; height: number };

/** A point given as shares of the box: `[0, 0]` top-left, `[1, 1]` bottom-right. */
export type UnitPoint = readonly [number, number];

export const polygon = (points: readonly XYPosition[]): string =>
  `${points.map(({ x, y }, index) => `${index === 0 ? 'M' : 'L'}${x} ${y}`).join('')}Z`;

/** The box position of a unit point. */
export const at = ({ x, y, width, height }: Box, [u, v]: UnitPoint): XYPosition => ({ x: x + u * width, y: y + v * height });

/** `x y` of a unit point, for writing path commands. */
export const pt = (box: Box, point: UnitPoint): string => {
  const { x, y } = at(box, point);
  return `${x} ${y}`;
};

/** A polygon through unit points, stretched to the box. */
export const unitPolygon = (box: Box, points: readonly UnitPoint[]): string => polygon(points.map((point) => at(box, point)));
